import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import { type MalleableUiPluginMeta, malleableUiPluginKey } from '../pm-plugins/plugin-key';

export const setShowLocationPickerEditorCommand =
	(showLocationPicker: boolean): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, { showLocationPicker } satisfies MalleableUiPluginMeta);

		return tr;
	};
